var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.118 8.916v1.487c0 .306-.251.557-.558.557h-2.6v2.6c0 .307-.25.558-.557.558H8.916a.559.559 0 0 1-.557-.558v-2.6h-2.6a.559.559 0 0 1-.558-.557V8.916c0-.306.251-.557.558-.557h2.6v-2.6c0-.307.251-.558.557-.558h1.487c.306 0 .557.251.557.558v2.6h2.6c.307 0 .558.251.558.557zm9.334 13.222-1.314 1.314a1.11 1.11 0 0 1-1.574 0l-4.635-4.63a1.114 1.114 0 0 1-.325-.79v-.756a9.612 9.612 0 0 1-5.944 2.043A9.658 9.658 0 0 1 0 9.659 9.658 9.658 0 0 1 9.66 0a9.658 9.658 0 0 1 9.659 9.66 9.612 9.612 0 0 1-2.043 5.944h.757c.297 0 .58.116.79.325l4.63 4.63a1.124 1.124 0 0 1 0 1.579zM15.975 9.66A6.31 6.31 0 0 0 9.66 3.344 6.31 6.31 0 0 0 3.344 9.66a6.31 6.31 0 0 0 6.316 6.315 6.31 6.31 0 0 0 6.315-6.315z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlus);
export default __webpack_public_path__ + "static/media/search-plus.aab1bc26675f14887bb31d28ad8cce03.svg";
export { ForwardRef as ReactComponent };